import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router';
import AssignSOP from './components/AssignSOP';
import { Layout } from './components/Layout';
import { MainPage } from './components/MainPage';
import { SOP } from './components/SOP';
import SOPSummary from './components/SOPSummary';
import PickSummary from './components/PickSummary';
import { WMSAuthentication } from './components/WMSAuthentication';

import './custom.css'
import SOPMoveRepick from './components/SOPMoveRepick';
import { NametagApproval } from './components/NametagApproval';
import { NametagReceiving } from './components/NametagReceiving';
import Cookies from 'universal-cookie';
import { BinPutaway } from './components/BinPutaway';
import ManageExpiration from './components/ManageExpiration';
import ItemLookup from './components/ItemLookup';
import ManageSublocations from './components/ManageSublocations';
import VehicleReservations from './components/VehicleReservations';
import TEST2 from './components/TEST2';
import TEST1 from './components/TEST1';
import TEST3 from './components/TEST3';
import TEST4 from './components/TEST4';

const cookies = new Cookies();

export default class App extends Component {
    static displayName = App.name;

    constructor(props) {
        super(props);
        this.state = {
            isAuthorized: false,
            userId: '',
            userName: ''
        };
        this.authenticateUser = this.authenticateUser.bind(this);
        this.checkForRefresh = this.checkForRefresh.bind(this);
        this.makeRESTCall = this.makeRESTCall.bind(this);
        this.logout = this.logout.bind(this);
        this.checkForRefresh();
    }

    authenticateUser(userId, userName, userPermissions, appPermissions) {
        console.log("USER PERMISSIONS", userPermissions);
        console.log("APP PERMISSIONS", appPermissions); 
        this.setState({
            isAuthorized: true,
            userId: userId,
            userName: userName,
            userPermissions: userPermissions,
            appPermissions: appPermissions
        });
    }

    async checkForRefresh() {
        await this.makeRESTCall(
            'wmsauthentication',
            'get',
            null,
            (checkAuthenticationInfo) => {
                if (checkAuthenticationInfo.success) {
                    if (checkAuthenticationInfo.isBYUEmployee && checkAuthenticationInfo.pinIsCorrect) {
                        this.authenticateUser(checkAuthenticationInfo.userId, checkAuthenticationInfo.userName, checkAuthenticationInfo.userPermissions, checkAuthenticationInfo.appPermissions);
                    }
                }
            },
            (title, error) => {
            },
            () => {
                
            }
        );
    }

    async makeRESTCall(URL, method, body, responseFunction, errorFunction, finalFunction) {
        var fetchParameters = {
            method: method,
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        }
        if (body) {
            fetchParameters.body = JSON.stringify(body);
        }
        await fetch(URL, fetchParameters).then(response => {
            if (!response.ok) {
                console.log("ERROR:", response);
                if (response.status == 401) {
                    return Promise.reject("Unauthorized");
                }
                else {
                    return Promise.reject("Unknown Error - Please contact I.T.");
                }
            }
            else {
                return response.json();
            }
        }).then((responseInfo) => {
            return responseFunction(responseInfo);
        }).catch((error) => {
            if (error == "Unauthorized") {
                console.log("UNATHORIZED");
                alert("Session Timeout: Your session has timed out and you will need to log in again");
                this.logout();
                //Log them out, they are unauthorized
            }
            else if (error.message == "Failed to fetch") {
                errorFunction("Unknown Error", "There was an Network error. Check your internet connection and try again");
            } else {
                errorFunction("Unknown Error", error);
            }
        }).finally(() => {
            finalFunction();
        });
    }

    async logout() {
        await this.makeRESTCall(
            'wmsauthentication',
            'post',
            {},
            () => {
                console.log("LOGGED OUT");
            },
            (title, error) => {
                console.log("ERROR", error);
            },
            () => {
            }
        );
        this.setState({
            isAuthorized: false,
            userId: '',
            userName: ''
        });
    }

    render() {
        const { isAuthorized, userId, userName, userPermissions, appPermissions } = this.state;

        if (isAuthorized) {
            return (
                <Layout logout={this.logout} userName={userName} userId={userId} userPermissions={userPermissions} appPermissions={appPermissions}>
                    <Route exact path='/TEST1' component={() => <TEST1 />} />
                    <Route exact path='/TEST2' component={() => <TEST2 />} />
                    <Route exact path='/TEST3' component={() => <TEST3 />} />
                    <Route exact path='/'
                        component={() => (
                            <MainPage
                                userId={userId}
                                userName={userName}
                                userPermissions={userPermissions}
                                appPermissions={appPermissions}
                                makeRESTCall={this.makeRESTCall}
                            />
                        )}
                    />

                    {userPermissions.includes(appPermissions.PICK_SALES_ORDERS) && (
                        <>
                            <Route exact path='/SOP' component={() => <SOP {...this.commonProps()} />} />
                            <Route exact path='/SOPSummary' component={() => <SOPSummary {...this.commonProps()} />} />
                            <Route exact path='/PickSummary' component={() => <PickSummary {...this.commonProps()} />} />
                            <Route exact path='/AssignSOP' component={() => <AssignSOP {...this.commonProps()} />} />
                            <Route exact path='/MoveRepick' component={() => <SOPMoveRepick {...this.commonProps()} />} />
                        </>
                    )}

                    {(userPermissions.includes(appPermissions.MANAGE_BINS) || userPermissions.includes(appPermissions.PICK_SALES_ORDERS)) && (
                        <Route exact path='/BinPutway' component={() => <BinPutaway {...this.commonProps()} />} />
                    )}

                    {userPermissions.includes(appPermissions.WMS_NAMETAGS) && (
                        <>
                            <Route exact path='/NametagReceiving' component={() => <NametagReceiving {...this.commonProps()} />} />
                            <Route exact path='/NametagApproval' component={() => <NametagApproval {...this.commonProps()} />} />
                        </>
                    )}

                    {userPermissions.includes(appPermissions.ITEM_LOOKUP) && (
                        <>
                            {userPermissions.includes(appPermissions.EXPIRATION_DATE_MANAGEMENT) && (
                                <Route exact path='/ManageExpiration' component={() => <ManageExpiration {...this.commonProps()} />} />
                            )}
                            {userPermissions.includes(appPermissions.SUBLOCATION_MANAGEMENT) && (
                                <Route exact path='/ManageSublocations' component={() => <ManageSublocations {...this.commonProps()} />} />
                            )}
                            <Route exact path='/ItemLookup' component={() => <ItemLookup {...this.commonProps()} />} />
                        </>
                    )}
                </Layout>
            );
        } else {
            return (
                <Switch>
                    <Route exact path='/' component={() => <WMSAuthentication
                        authenticateUser={this.authenticateUser}
                        makeRESTCall={this.makeRESTCall}
                    />} />
                    {
                        //We need a page for Vehicle Reservations, and while not part of WMS we will place it here
                        //We want it to be accessable without having a WMS login
                    }
                    <Route exact path='/vehicleReservations/:id?' component={() => <VehicleReservations
                        makeRESTCall={this.makeRESTCall}
                    />} />
                    <Route exact path='/TEST1' component={() => <TEST1 />} />
                    <Route exact path='/TEST2' component={() => <TEST2 />} />
                    <Route exact path='/TEST3' component={() => <TEST3 />} />
                    <Route exact path='/TEST4' component={() => <TEST4 />} />
                    <Redirect to="/" />
                </Switch>
            );
        }
    }

    commonProps = () => ({
        userId: this.state.userId,
        userName: this.state.userName,
        userPermissions: this.state.userPermissions,
        appPermissions: this.state.appPermissions,
        makeRESTCall: this.makeRESTCall
    });
}
